document.addEventListener('DOMContentLoaded', function () {
  const videos = document.querySelectorAll('.product__media--video-container video');
  const modalContent = document.querySelector('.product-media-modal');
  let isVideoOnScreen = false;

  // Detects if user is on Safari
  function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  // ifSafari, removes the onclick and ontouchend attributes which stop the controls working on Safari
  if (isSafari()) {
    videos.forEach((video) => {
      if (video.hasAttribute('onclick')) {
        video.removeAttribute('onclick');
      }
      if (video.hasAttribute('ontouchend')) {
        video.removeAttribute('ontouchend');
      }
    });
  }

  function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      // const video = entry.target;
      // isVideoOnScreen = entry.isIntersecting;

      // if (entry.isIntersecting) {
      //   if (video.classList.contains('manual-play') && !video.classList.contains('manual-pause')) {
      //     video.play();
      //   } else if (!video.classList.contains('manual-play') && video.classList.contains('manual-pause')) {
      //     video.pause();
      //   } else if (!video.classList.contains('manual-play') && !video.classList.contains('manual-pause')) {
      //     if (video.hasAttribute('autoplay')) {
      //       video.play();
      //     } else if (!video.hasAttribute('autoplay')) {
      //       video.pause();
      //     }
      //   }
      // } else if (!entry.isIntersecting) {
      //   video.pause();
      // }
    });
  }

  const observer = new IntersectionObserver(handleIntersection, {
    root: null,
    threshold: 0.5
  });

  videos.forEach((video) => {
    observer.observe(video);
  });
  
  // Detect any pause to check if it’s manual (on screen) or automatic (offscreen)
  videos.forEach((video) => {
    video.addEventListener('pause', function() {
      if (isVideoOnScreen && video.paused) {
        video.classList.add('manual-pause');
        video.classList.remove('manual-play');
      }
    });
    video.addEventListener('play', function() {
      if (isVideoOnScreen && !video.paused) {
        video.classList.add('manual-play');
        video.classList.remove('manual-pause');
      }
    });
  });

  // Simulates a click on the deferred media video when modal is open
  function autoTriggerDeferredMedia() {
    const deferredMediaElements = modalContent.querySelectorAll('.deferred-media');
    deferredMediaElements.forEach((element) => {
      if (!element.classList.contains('pauseAllMedia-ignore')) {
        element.classList.add('pauseAllMedia-ignore');
      }
      const button = element.querySelector('button');
      if (button) button.click();
    });
  }

  // Observes for the open attribute on modalContent
  const modalObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        if (modalContent.hasAttribute('open')) {
          autoTriggerDeferredMedia();
        }
      }
    });
  });

  modalObserver.observe(modalContent, { attributes: true });
});